import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import collection from "./data/collection.json"
import { heat, heatOf } from "./lib"

const counts: Record<string, Record<string, number>> = collection.counts


const TraitStats = () => (
	<>
		<Box sx={{ display: "flex", flexWrap: "wrap", gap: 2.5, mb: 2 }}>
			{heat.map(h => (
				<Box key={h.label} sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: ".875rem", color: "text.secondary" }}>
					<Box sx={{ width: 12, height: 12, borderRadius: "50%", bgcolor: h.color }} />{h.label}
				</Box>
			))}
		</Box>
		<Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 2, alignItems: "start" }}>
			{Object.entries(counts).map(([type, values]) => {
				const rows = Object.entries(values).sort((a, b) => a[1] - b[1])
				const max = rows[rows.length - 1][1]
				return (
					<Accordion key={type} disableGutters elevation={0}
						sx={{ borderRadius: 1, border: "1px solid rgba(43,45,66,.08)", "&::before": { display: "none" } }}>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Box>
								<Typography sx={{ fontWeight: 600 }}>
									{type} <Box component="span" sx={{ color: "text.secondary", fontWeight: 400 }}>· {rows.length} values</Box>
								</Typography>
								{/* Mini heat strip: one segment per value, rarest first */}
								<Box sx={{ display: "flex", gap: "2px", mt: 1, height: 6, width: { xs: 200, sm: 260 } }}>
									{rows.map(([value, n]) => <Box key={value} sx={{ flex: 1, borderRadius: 1, bgcolor: heatOf(n / collection.total * 100) }} />)}
								</Box>
							</Box>
						</AccordionSummary>
						<AccordionDetails sx={{ pt: 0 }}>
							{rows.map(([value, n]) => {
								const pct = n / collection.total * 100
								return (
									<Box key={value} sx={{ py: .75 }}>
										<Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, fontSize: ".875rem" }}>
											<span>{value}</span>
											<Box component="span" sx={{ color: "text.secondary", whiteSpace: "nowrap" }}>
												{n} · <Box component="b" sx={{ color: "text.primary" }}>{pct.toFixed(2)}%</Box>
											</Box>
										</Box>
										<Box sx={{ mt: .5, height: 6, borderRadius: 3, bgcolor: "rgba(43,45,66,.06)" }}>
											<Box sx={{ width: `${n / max * 100}%`, minWidth: 6, height: "100%", borderRadius: 3, bgcolor: heatOf(pct) }} />
										</Box>
									</Box>
								)
							})}
						</AccordionDetails>
					</Accordion>
				)
			})}
		</Box>
	</>
)

export default TraitStats
